export default {
    productLoading: false,
    productsListLoading: false,
    productsList: [],
}